import { Button, Tooltip } from "@material-ui/core";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import EventLabel from "../../components/EventLabel";

export const ForwardPage = observer(({ current, contentLayout, text, triggerValidation, validations, checkInvoiceValidation, grpRegDisabled = false, setActivePage, getFilteredValidations }) => {
  let isValid = getFilteredValidations().length == 0;
  return (
    <Tooltip
      title={<EventLabel name="GroupRegMinCountValidationMessage" groupName="CMS.GROUPMODULE" textOnly={true} />}
      disableHoverListener={!grpRegDisabled}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <button
          className="cms-button"
          disabled={current.activePage == contentLayout.pages}
          onClick={() =>
            runInAction(() => {
              isValid = checkInvoiceValidation(isValid);
              if (isValid) {
                triggerValidation(false);
                if (!grpRegDisabled) {
                  setActivePage(current.activePage+1)
                }
              } else {
                triggerValidation();
              }
            })
          }
        >
          {text || <SystemLabel name="NextPage" />}
        </button>
      </div>
    </Tooltip>
  );
});
